module.exports = __webpack_public_path__ + "media/src/images/landing/cup-with-stars-12a5823a5e0b372a16e5fa490329b949.svg";